// extracted by mini-css-extract-plugin
export default {"root":"DesignSettingsTab_root__cDNzT"};